import script from "./Trips.vue?vue&type=script&setup=true&lang=js"
export * from "./Trips.vue?vue&type=script&setup=true&lang=js"

import "./Trips.vue?vue&type=style&index=0&id=cb8c2494&lang=css"

const __exports__ = script;

export default __exports__